@if(isLoading && router.url === '/kontakt'){
<div class="loader-container">
  <div class="loader"></div>
</div>
}

 @if(!isLoading && router.url === '/kontakt'){
    <div class="hs-form-frame absolute lg:w-[60%] max-w-[1000px] w-full top-10 left-1/2 -translate-x-1/2 transform bg-transparent" data-region="na1" data-form-id="4b561819-3157-4067-8bc7-85b6d20b0581" data-portal-id="49530899"></div>
  }

  <router-outlet></router-outlet>
